"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = 'M12 21a9 9 0 1 1 0-18 9 9 0 0 1 0 18zm-1.74-4.188c.154.13.35.2.552.2.05-.001.05-.001.116-.008a.864.864 0 0 0 .591-.358l5.413-7.596a.867.867 0 1 0-1.413-1.005l-4.871 6.837-2.607-2.159a.867.867 0 0 0-1.106 1.335l3.324 2.754z';